import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations } from "@/store/enums/StoreEnums";
import { useUsuarioStore } from "@/store/usuarioStore";
import KeycloakService from "@/core/services/KeycloakService";
import MensagemService from "@/core/services/MensagemService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      breadCrumb: "Bem-vindo(a)",
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
    ],
  },
  {
    path: "/escolas",
    redirect: "/escolas",
    meta: {
      breadCrumb: "Administração Escolar - Escola",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/escolas/visualizar/:id",
        meta: {
          allowedPermissions: ["escola_show"],
        },
        name: "escolas_visualizar",
        component: () => import("@/views/Escolas/EscolasVisualizar.vue"),
      },
      {
        path: "/escolas/editar/:id",
        name: "escolas_atualizar",
        meta: {
          allowedPermissions: ["escola_edit"],
        },
        component: () => import("@/views/Escolas/EscolasEdit.vue"),
      },
      {
        path: "/escolas/manutencao-de-salas/:id",
        name: "escolas_manutencao_de_salas",
        meta: {
          allowedPermissions: ["salaescola_list"],
        },
        component: () =>
          import(
            "@/views/Escolas/ManutencaoDeSalas/EscolasManutencaoDeSalasHome.vue"
          ),
      },
      {
        path: "/escolas/manutencao-de-salas/:id/editar",
        name: "escolas_manutencao_de_salas_edit",
        meta: {
          allowedPermissions: ["salaescola_edit"],
        },
        component: () =>
          import(
            "@/views/Escolas/ManutencaoDeSalas/EscolasManutencaoDeSalasEdit.vue"
          ),
      },
      {
        path: "/escolas/manutencao-de-salas/:id/visualizar",
        name: "escolas_manutencao_de_salas_visualizar",
        meta: {
          allowedPermissions: ["salaescola_show"],
        },
        component: () =>
          import(
            "@/views/Escolas/ManutencaoDeSalas/EscolasManutencaoDeSalasVisualizar.vue"
          ),
      },
      {
        path: "/escolas/manutencao-de-salas/:id/novo",
        name: "escolas_manutencao_de_salas_cad",
        meta: {
          allowedPermissions: ["salaescola_create"],
        },
        component: () =>
          import(
            "@/views/Escolas/ManutencaoDeSalas/EscolasManutencaoDeSalasCad.vue"
          ),
      },
      {
        path: "/escolas/atualizacao-cadastro-uso-informatica-censo/:id",
        name: "atualizacao_cadastro_uso_informatica_censo",
        meta: {
          allowedPermissions: ["escolausoinformatica_edit"],
        },
        component: () =>
          import(
            "@/views/Escolas/CadastroDeUsoDeInformaticaParaCenso/CadastroDeUsoDeInformaticaParaCenso.vue"
          ),
      },
      {
        path: "/escolas/atualizacao-de-dados-tecnicos/:id",
        name: "escolas_atualizacao_de_dados_tecnicos",
        meta: {
          allowedPermissions: ["tecnicos_escola_show"],
        },
        component: () =>
          import(
            "@/views/Escolas/AtualizacaoDeDadosTecnicos/EscolasAtualizacaoDeDadosTecnicos.vue"
          ),
      },
      {
        path: "/escolas/manutencao-de-equipamento/:id",
        name: "escolas_manutencao_de_equipamento",
        meta: {
          allowedPermissions: ["equipamento_escola_list"],
        },
        component: () =>
          import(
            "@/views/Escolas/ManutencaoDeEquipamento/EscolasManutencaoDeEquipamento.vue"
          ),
      },
      {
        path: "/escolas/manutencao-de-caracterizacao-infraestrutura/:id",
        name: "escolas_manutencao_de_caracterizacao_infraestrutura",
        meta: {
          allowedPermissions: ["caracterizacao_escola_list"],
        },
        component: () =>
          import(
            "@/views/Escolas/ManutencaoDeCaracterizacaoInfraEstrutura/ManutencaoDeCaracterizacaoInfraEstrutura.vue"
          ),
      },
      {
        path: "/escolas/manutencao-de-indicadores/:id",
        name: "escolas_manutencao_de_indicadores",
        meta: {
          allowedPermissions: ["indicadoresescola_show"],
        },
        component: () =>
          import(
            "@/views/Escolas/ManutencaoDeIndicadores/EscolasManutencaoDeIndicadores.vue"
          ),
      },
      {
        path: "/escolas/novo",
        name: "escolas_novo",
        meta: {
          allowedPermissions: ["escola_create"],
        },
        component: () => import("@/views/Escolas/EscolasCadastro.vue"),
      },
      {
        path: "/escolas/historico-de-alteracao-da-escola/:id",
        name: "escolas_historico_de_alteracao_da_escola",
        meta: {
          allowedPermissions: ["historico_escola_list"],
        },
        component: () =>
          import(
            "@/views/Escolas/EscolaHistoricoDeAlteracaoDaEscola/index.vue"
          ),
      },
      {
        path: "/escolas/historico-de-alteracao-da-escola/:baseId/:destinoId",
        name: "escolas_historico_de_alteracao_da_escola_visualizar",
        meta: {
          allowedPermissions: ["historico_escola_show"],
        },
        component: () =>
          import(
            "@/views/Escolas/EscolaHistoricoDeAlteracaoDaEscola/Visualizar.vue"
          ),
      },
      {
        path: "/escolas",
        name: "escolas",
        meta: {
          allowedPermissions: ["escola_list"],
        },
        component: () => import("@/views/Escolas/EscolasHome.vue"),
      },
    ],
  },
  {
    path: "/tipos-de-sala",
    redirect: "/tipos-de-sala",
    meta: {
      breadCrumb: "Administração Escolar - Tipos De Sala",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/tipos-de-sala",
        name: "tipos_de_sala",
        meta: {
          allowedPermissions: ["tiposala_list"],
        },
        component: () => import("@/views/TiposDeSala/TiposDeSala.vue"),
      },
      {
        path: "/tipos-de-sala/:id",
        name: "tipos_de_sala_edit",
        meta: {
          allowedPermissions: ["tiposala_edit"],
        },
        component: () => import("@/views/TiposDeSala/TiposDeSalaEdit.vue"),
      },
      {
        path: "/tipos-de-sala/novo",
        name: "tipos_de_sala_cad",
        meta: {
          allowedPermissions: ["tiposala_create"],
        },
        component: () => import("@/views/TiposDeSala/TiposDeSalaCad.vue"),
      },
    ],
  },
  {
    path: "/relacao-de-escolas-anexas",
    redirect: "/relacao-de-escolas-anexas",
    meta: {
      breadCrumb: "Administração Escolar - Relatórios de Escolas",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/relacao-de-escolas-anexas",
        name: "relacao-de-escolas-anexas",
        meta: {
          allowedPermissions: ["relacao_escolas_anexas"],
        },
        component: () =>
          import("@/views/RelacaoDeEscolasAnexas/RelacaoDeEscolasAnexas.vue"),
      },
    ],
  },
  {
    path: "/escolas-extra-rede",
    redirect: "/escolas-extra-rede",
    meta: {
      breadCrumb: "Administração Escolar - Escolas Extra Rede",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/escolas-extra-rede",
        name: "escolas_extra_rede",
        meta: {
          allowedPermissions: ["escola_extra_rede_list"],
        },
        component: () =>
          import("@/views/EscolasExtraRede/EscolasExtraRede.vue"),
      },
      {
        path: "/escolas-extra-rede/:id",
        name: "escolas_extra_rede_edit",
        meta: {
          allowedPermissions: ["escola_extra_rede_edit"],
        },
        component: () =>
          import("@/views/EscolasExtraRede/EscolasExtraRedeEdit.vue"),
      },
      {
        path: "/escolas-extra-rede/novo",
        name: "escolas_extra_rede_cad",
        meta: {
          allowedPermissions: ["escola_extra_rede_create"],
        },
        component: () =>
          import("@/views/EscolasExtraRede/EscolasExtraRedeCad.vue"),
      },
    ],
  },
  {
    path: "/caracterizacao-infraestrutura",
    redirect: "/caracterizacao-infraestrutura",
    meta: {
      breadCrumb:
        "Administração Escolar - Manutenção de Caracterização/ Infraestrutura",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/caracterizacao-infraestrutura",
        name: "caracterizacao_infraestrutura",
        meta: {
          allowedPermissions: ["caracterizacao_list"],
        },
        component: () =>
          import(
            "@/views/CaracterizacaoInfraestrutura/CaracterizacaoInfraestrutura.vue"
          ),
      },
      {
        path: "/caracterizacao-infraestrutura/:id",
        name: "caracterizacao_infraestrutura_edit",
        meta: {
          allowedPermissions: ["caracterizacao_edit"],
        },
        component: () =>
          import(
            "@/views/CaracterizacaoInfraestrutura/CaracterizacaoInfraestruturaEdit.vue"
          ),
      },
      {
        path: "/caracterizacao-infraestrutura/novo",
        name: "caracterizacao_infraestrutura_cad",
        meta: {
          allowedPermissions: ["caracterizacao_create"],
        },
        component: () =>
          import(
            "@/views/CaracterizacaoInfraestrutura/CaracterizacaoInfraestruturaCad.vue"
          ),
      },
    ],
  },
  {
    path: "/tipo-de-caracterizacao-infraestrutura",
    redirect: "/tipo-de-caracterizacao-infraestrutura",
    meta: {
      breadCrumb:
        "Administração Escolar - Manutenção de Caracterização/ Infraestrutura",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/tipo-de-caracterizacao-infraestrutura",
        name: "tipo_de_caracterizacao_infraestrutura",
        meta: {
          allowedPermissions: ["tipo_caracterizacao_list"],
        },
        component: () =>
          import(
            "@/views/TipoCaracterizacaoInfraestrutura/TipoCaracterizacaoInfraestrutura.vue"
          ),
      },
      {
        path: "/tipo-de-caracterizacao-infraestrutura/:id",
        name: "tipo_de_caracterizacao_infraestrutura_edit",
        meta: {
          allowedPermissions: ["tipo_caracterizacao_edit"],
        },
        component: () =>
          import(
            "@/views/TipoCaracterizacaoInfraestrutura/TipoCaracterizacaoInfraestruturaEdit.vue"
          ),
      },
      {
        path: "/tipo-de-caracterizacao-infraestrutura/novo",
        name: "tipo_de_caracterizacao_infraestrutura_cad",
        meta: {
          allowedPermissions: ["tipo_caracterizacao_create"],
        },
        component: () =>
          import(
            "@/views/TipoCaracterizacaoInfraestrutura/TipoCaracterizacaoInfraestruturaCad.vue"
          ),
      },
    ],
  },
  {
    path: "/manutencao-info-web",
    redirect: "/escolas/pesquisa-matricula-manutencao-info-web",
    meta: {
      breadCrumb:
        "Administração Escolar - Manutenção de Escolas Participantes da Matrícula Web - Informatizada",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/escolas/pesquisa-matricula-manutencao-info-web",
        name: "pesquisa_matricula_manutencao_info_web",
        meta: {
          allowedPermissions: ["escola_alterarmatriculainfoweb"],
        },
        component: () =>
          import(
            "@/views/MatriculaInfoWeb/PesquisaManutencaoMatriculaInfoWeb.vue"
          ),
      },
      {
        path: "/escolas/matricula-manutencao-info-web/:rede_ensino/:municipio/:coordenadoria",
        name: "matricula_manutencao_info_web",
        meta: {
          allowedPermissions: ["escola_pegarmatriculainfoweb"],
        },
        component: () =>
          import("@/views/MatriculaInfoWeb/ManutencaoMatriculaInfoWeb.vue"),
      },
    ],
  },
  {
    path: "/escolas-por-tipo-de-conexao",
    redirect: "/escolas-por-tipo-de-conexao",
    meta: {
      breadCrumb: "Administração Escolar - Relatórios de Escolas",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/escolas-por-tipo-de-conexao",
        name: "escolas_por_tipo_de_conexao",
        meta: {
          allowedPermissions: ["escola_tipo_conexao_listagem"],
        },
        component: () =>
          import("@/views/EscolasPorTipoDeConexao/EscolasPorTipoDeConexao.vue"),
      },
    ],
  },
  {
    path: "/manutencao_sala_recurso_multfuncional",
    redirect: "/manutencao_sala_recurso_multfuncional",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      breadCrumb:
        "Administração Escolar - Manutenção de Sala de Recurso E Multifuncional",
    },
    children: [
      {
        path: "/escolas/manutencao_sala_recurso_multfuncional/:id",
        name: "manutencao_sala_recurso_multfuncional",
        meta: {
          allowedPermissions: ["salaespecial_list"],
        },
        component: () =>
          import(
            "@/views/Escolas/ManutencaoSalaRecursoMultFuncional/ManutencaoSalaRecursoMultFuncionalHome.vue"
          ),
      },
    ],
  },
  {
    path: "/relatorio-escola-matricula-informatizada",
    redirect: "/relatorio-escola-matricula-informatizada",
    meta: {
      breadCrumb: "Administração Escolar - Relatório de Escolas",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/relatorio-escola-matricula-informatizada",
        name: "relatorio_ecola_matricula_informatizada",
        meta: {
          allowedPermissions: ["escola_pegarmatriculainfoweb"],
        },
        component: () =>
          import(
            "@/views/RelatoriosEscolaComMatriculaInformatizada/RelatoriosEscolaComMatriculaInformatizada.vue"
          ),
      },
    ],
  },
  {
    path: "/relatorio-relacao-de-escolas",
    redirect: "/relatorio-relacao-de-escolas",
    meta: {
      breadCrumb: "Administração Escolar - Relatório de Escolas",
    },
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/relatorio-relacao-de-escolas",
        name: "relatorio_relacao_escolas",
        meta: {
          allowedPermissions: ["escola_relacao"],
        },
        component: () =>
          import("@/views/RelatorioRelacaoEscolas/RelatorioRelacaoEscolas.vue"),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function validarAutorizacao(to, permissions) {
  if (to.meta.requireAuth === false) {
    return true;
  }

  if (!KeycloakService.getInstance().authenticated) {
    KeycloakService.getInstance().login();
  }

  if (!to.meta.allowedPermissions) {
    return true;
  }

  if (!Array.isArray(to.meta.allowedPermissions)) {
    return false;
  }

  if (to.meta.allowedPermissions.some((item) => permissions.includes(item))) {
    return true;
  }

  return false;
}

router.beforeEach(async (to, from, next) => {
  //reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  const usuarioStore = useUsuarioStore();
  if (!usuarioStore.dadosCarregados) {
    try {
      await usuarioStore.carregarDadosUsuario();
    } catch (error) {
      console.error("Erro ao carregar dados do usuário:", error);
    }
  }

  const storedMenuData: string = localStorage.getItem("menuData") || "";
  const permissions = Object.values(JSON.parse(storedMenuData)).flat();

  if (validarAutorizacao(to, permissions)) {
    next();
  } else {
    MensagemService.erro({
      texto: "Você não tem permissão para acessar este recurso!",
      confirmButtonText: "OK",
    });
  }

  //Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
